// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.parameter-widget {
  margin-bottom: 40px;
}

.parameter-header {
  margin-bottom: 8px;
}

.parameter-title {
  font-family:
    'SF Pro Text',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.4em;
  color: rgba(0, 0, 0, 0.88);
  margin: 0 0 8px 0;
}

.parameter-divider {
  margin: 0;
  border-top: 1px solid #d9d9d9;
}

.parameter-content {
  display: flex;
  flex-direction: column;
}

.parameter-item {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 0;
}

.parameter-item-divider {
  margin: 0;
  border-top: 1px solid #f0f0f0;
}

/* Row with parameter name and tags */
.parameter-item-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

/* Parameter name styling */
.parameter-name {
  font-family:
    'SF Pro Text',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5714285714285714em;
  color: #5b8c00;
}

.parameter-tag-default {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 1px 8px;
  background: rgba(0, 0, 0, 0.02);
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-family:
    'SF Pro Text',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.6666666666666667em;
  color: rgba(0, 0, 0, 0.88);
  margin: 0;
}

.parameter-tag-required {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 1px 8px;
  background: #fff1f0;
  border: none;
  border-radius: 4px;
  font-family:
    'SF Pro Text',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.6666666666666667em;
  color: #f5222d;
  margin: 0;
}

.parameter-tag-deprecated {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 1px 8px;
  background: #fff7e6;
  border: none;
  border-radius: 4px;
  font-family:
    'SF Pro Text',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.6666666666666667em;
  color: #d46b08;
  margin: 0;
}

.parameter-description {
  font-family:
    'SF Pro Text',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5714285714285714em;
  color: rgba(0, 0, 0, 0.65);
  margin: 0;
}

.parameter-example {
  font-family:
    'SF Pro Text',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.6666666666666667em;
  color: rgba(0, 0, 0, 0.65);
  margin: 0;
}

.parameter-example-label {
  font-weight: 600;
  color: rgba(0, 0, 0, 0.88);
}

.parameter-enum {
  font-family:
    'SF Pro Text',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.6666666666666667em;
  color: rgba(0, 0, 0, 0.65);
  margin: 0;
}

.parameter-enum-label {
  font-weight: 600;
  color: rgba(0, 0, 0, 0.88);
}

/* Show child attributes button */
.parameter-child-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: auto;
  padding: 12px 16px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  background: #ffffff;
  text-align: left;
  font-family:
    'SF Pro Text',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5714285714285714em;
  color: rgba(0, 0, 0, 0.88);
}

.parameter-child-button:hover {
  background: #fafafa;
  border-color: #40a9ff;
}

.parameter-child-button .anticon {
  color: rgba(0, 0, 0, 0.45);
}

.parameter-children {
  margin-left: 24px;
  padding-left: 16px;
  border-left: 2px solid #e6f4ff;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ApiDocsViewer/EndPointSection/components/ParameterWidget/ParameterWidget.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;;;;;cAKY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,6BAA6B;AAC/B;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE;;;;;cAKY;EACZ,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;EACzB,kBAAkB;EAClB;;;;;cAKY;EACZ,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB;;;;;cAKY;EACZ,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB;;;;;cAKY;EACZ,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,cAAc;EACd,SAAS;AACX;;AAEA;EACE;;;;;cAKY;EACZ,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE;;;;;cAKY;EACZ,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE;;;;;cAKY;EACZ,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB;;;;;cAKY;EACZ,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX","sourcesContent":[".parameter-widget {\n  margin-bottom: 40px;\n}\n\n.parameter-header {\n  margin-bottom: 8px;\n}\n\n.parameter-title {\n  font-family:\n    'SF Pro Text',\n    -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    sans-serif;\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 1.4em;\n  color: rgba(0, 0, 0, 0.88);\n  margin: 0 0 8px 0;\n}\n\n.parameter-divider {\n  margin: 0;\n  border-top: 1px solid #d9d9d9;\n}\n\n.parameter-content {\n  display: flex;\n  flex-direction: column;\n}\n\n.parameter-item {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px 0;\n}\n\n.parameter-item-divider {\n  margin: 0;\n  border-top: 1px solid #f0f0f0;\n}\n\n/* Row with parameter name and tags */\n.parameter-item-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n/* Parameter name styling */\n.parameter-name {\n  font-family:\n    'SF Pro Text',\n    -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.5714285714285714em;\n  color: #5b8c00;\n}\n\n.parameter-tag-default {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  padding: 1px 8px;\n  background: rgba(0, 0, 0, 0.02);\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  font-family:\n    'SF Pro Text',\n    -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 1.6666666666666667em;\n  color: rgba(0, 0, 0, 0.88);\n  margin: 0;\n}\n\n.parameter-tag-required {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  padding: 1px 8px;\n  background: #fff1f0;\n  border: none;\n  border-radius: 4px;\n  font-family:\n    'SF Pro Text',\n    -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 1.6666666666666667em;\n  color: #f5222d;\n  margin: 0;\n}\n\n.parameter-tag-deprecated {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  padding: 1px 8px;\n  background: #fff7e6;\n  border: none;\n  border-radius: 4px;\n  font-family:\n    'SF Pro Text',\n    -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 1.6666666666666667em;\n  color: #d46b08;\n  margin: 0;\n}\n\n.parameter-description {\n  font-family:\n    'SF Pro Text',\n    -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.5714285714285714em;\n  color: rgba(0, 0, 0, 0.65);\n  margin: 0;\n}\n\n.parameter-example {\n  font-family:\n    'SF Pro Text',\n    -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 1.6666666666666667em;\n  color: rgba(0, 0, 0, 0.65);\n  margin: 0;\n}\n\n.parameter-example-label {\n  font-weight: 600;\n  color: rgba(0, 0, 0, 0.88);\n}\n\n.parameter-enum {\n  font-family:\n    'SF Pro Text',\n    -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 1.6666666666666667em;\n  color: rgba(0, 0, 0, 0.65);\n  margin: 0;\n}\n\n.parameter-enum-label {\n  font-weight: 600;\n  color: rgba(0, 0, 0, 0.88);\n}\n\n/* Show child attributes button */\n.parameter-child-button {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  height: auto;\n  padding: 12px 16px;\n  border: 1px solid #d9d9d9;\n  border-radius: 8px;\n  background: #ffffff;\n  text-align: left;\n  font-family:\n    'SF Pro Text',\n    -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.5714285714285714em;\n  color: rgba(0, 0, 0, 0.88);\n}\n\n.parameter-child-button:hover {\n  background: #fafafa;\n  border-color: #40a9ff;\n}\n\n.parameter-child-button .anticon {\n  color: rgba(0, 0, 0, 0.45);\n}\n\n.parameter-children {\n  margin-left: 24px;\n  padding-left: 16px;\n  border-left: 2px solid #e6f4ff;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
